import type { Components, Theme } from '@mui/material';

import { pxToRem } from '../utils';

export const getMuiChip = (
    rootFontSize = 16
): Components<Theme>['MuiChip'] => ({
    defaultProps: {
        //@ts-expect-error https://github.com/mui/material-ui/issues/29033
        disableRipple: true,
    },
    styleOverrides: {
        root: {
            borderRadius: '4px',
            fontWeight: 600,
            fontSize: pxToRem(14, rootFontSize),
        },
    },
});
